export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    // 签约记录
    getOnlineContractList: function getOnlineContractList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/onlineContract/list",
        method: "get",
        params: data
      });
    },
    // 纠纷状态数量
    getDisputeStatus: function getDisputeStatus() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/dispute/status",
        method: "get",
        params: data
      });
    },
    // 纠纷列表
    getDisputeList: function getDisputeList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/dispute/list",
        method: "get",
        params: data
      });
    },
    // 认领
    disputeClaim: function disputeClaim() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/dispute/claim",
        method: "post",
        data: data
      });
    },
    // 标记已处理
    disputeProcessed: function disputeProcessed() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/dispute/processed",
        method: "post",
        data: data
      });
    },
    // 更新纠纷操作说明
    updateOperation: function updateOperation() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/dispute/updateOperation",
        method: "post",
        data: data
      });
    },
    // 流水记录
    getUserRecordList: function getUserRecordList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/userRecord/list",
        method: "get",
        params: data
      });
    }
  };
});